/**
 * Domain detection for admin vs payment app.
 * admin.yap.net.do → restaurant dashboard
 * pay.yap.net.do   → customer QR payment flow
 */

const hostname = typeof window !== 'undefined' ? window.location.hostname : '';

export const isAdminDomain = hostname.startsWith('admin');
export const isPayDomain = hostname.startsWith('pay');

/** Base URL for customer payment app (used in QR codes and links from admin). */
export const PAY_DOMAIN_URL =
  process.env.REACT_APP_PAY_URL || 'https://pay.yap.net.do';

/**
 * Returns the full URL for a mesa payment page (used when generating QR codes in admin).
 * Always points to the payment domain so customers never hit admin.
 */
export function getMesaPaymentUrl(mesaId: string): string {
  return `${PAY_DOMAIN_URL}/m/${mesaId}`;
}
